<template>
    <table class="mb-6 contract-availability-table full-width">
        <thead>
            <tr class="service-name-row">
                <th class="pl-2 text-grey-darken-1" :colspan="dates.length + 1">
                    {{ $t(name) }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="td-header text-caption pl-2">
                    <span class="text-no-wrap">{{ $filters.dateShortFormat(dateFrom) }}</span> -
                    <span class="text-no-wrap">{{ $filters.dateShortFormat(dateTo) }}</span>
                </td>
                <td v-for="day in dates" :key="`${day}`" :class="dateCellCSSClass(day)">
                    <div class="date-cell">
                        {{ day.toLocaleString($i18n.locale, {weekday: 'short'}) }}
                    </div>
                    <div class="date-cell-day">
                        {{ day.getDate() }}
                    </div>
                </td>
            </tr>
            <slot name="release" />
            <AvailabilityTableRows
                :availability-type="availabilityType"
                allotment-type="NETTO"
                :dates="dates"
                :contract="contract"
            />
            <!-- UI-32: commented out the "Free sale TO" (FREE_SALE) allotment section.
                 zsh is an OTA, not a Tour Operator. NETTO ("Net") is kept — it is the
                 system's base allotment (mass-edit default; used in reports/pricing).
                 "Free sale TO" is labeled "TO" (Tour Operator) and is the redundant
                 secondary section. Commented rather than deleted so it is trivial to
                 restore if the OTA/TO decision is reversed. -->
            <!--
            <AvailabilityTableRows
                :availability-type="availabilityType"
                allotment-type="FREE_SALE"
                :dates="dates"
                content-class="bg-blue-lighten-4"
                :contract="contract"
            />
            -->
            <template v-if="false">
                <AvailabilityTableRows
                    v-for="subAllotment in subAllotments"
                    :key="subAllotment.id"
                    :availability-type="availabilityType"
                    :allotment-type="'CUSTOMER'"
                    :dates="dates"
                    :sub-allotment="subAllotment"
                    :contract="contract"
                />
            </template>
        </tbody>
    </table>
</template>

<script setup lang="ts">
    import AvailabilityTableRows from './AvailabilityTableRows.vue'

    const {inventory, dates, contract} = defineProps<{
        inventory: any
        dates: Date[]
        dateFrom: Date
        dateTo: Date
        subAllotments: any
        contract?: any
    }>()

    const {name, availabilityType} = inventory

    function dateCellCSSClass(day: Date) {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const dayDate = new Date(day)
        dayDate.setHours(0, 0, 0, 0)

        if (dayDate.getTime() === today.getTime()) {
            return 'bg-blue-lighten-5'
        }
        return ''
    }
</script>

<style scoped lang="scss">
    :deep(div) {
        table.contract-availability-table {
            margin: 0 auto;
        }
        table.contract-availability-table td {
            min-width: 40px;
            height: 40px !important;
            cursor: pointer;
            padding: 2px;
        }

        table.contract-availability-table td,
        table.contract-availability-table th {
            border: 1px solid #dee2e6;
        }

        table.contract-availability-table td,
        table.contract-availability-table th {
            vertical-align: middle;
        }

        table.contract-availability-table td:nth-child(1) {
            padding-left: 5px;
            font-size: 14px;
        }

        // UI-33: keep each room name / type / ID on a single line (no wrapping) so the
        // first column auto-sizes to the widest room name instead of overflowing the cell.
        table.contract-availability-table td:nth-child(1) > div {
            white-space: nowrap;
        }

        .date-cell {
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #9b9b9b;
        }

        .date-cell-day {
            font-size: 20px;
            font-weight: 400;
            color: #1c1c1c;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
        }

        .service-name-row {
            height: 35px;
            font-size: 20px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #000a12;
        }

        .service-name-row th {
            padding-left: 5px;
        }

        .td-header {
            position: relative;
            background: white;
            min-height: 77px;
            vertical-align: middle;
            min-width: 160px;
        }

        .v-text-field {
            padding-top: 0 !important;
        }

        table.contract-availability-table .v-input input {
            text-align: center;
        }

        table.contract-availability-table input::-webkit-outer-spin-button,
        table.contract-availability-table input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        table.contract-availability-table input[type='number'] {
            -moz-appearance: textfield;
        }
    }
</style>
